import React, { useEffect, useState } from 'react';
import { Box, IconButton, TableCell, TableRow } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { ICriteriaRating, IPartnerRatingByPartner, IRealEstateRatingByPartner, IServiceType } from '../../../interfaces';
import { useExportPartnerRatingByRealEstateExcelReport, useGetRealEstateRatingByPartner } from '../../../hooks';
import PartnerRatingByMonthTableRow from './PartnerRatingByMonthTableRow';

interface IProps {
  year: number;
  serviceType?: IServiceType;
  partnerRating: IPartnerRatingByPartner;
  realEstateRating: IRealEstateRatingByPartner;
  criteriaRatingsByServiceType: ICriteriaRating[];
}

const PartnerRatingTableRow = ({
  partnerRating,
  realEstateRating,
  serviceType,
  year,
  criteriaRatingsByServiceType,
}: IProps) => {
  const [open, setOpen] = useState(false);

  const {
    criteriaRatings,
    countNegative,
    countOvksPositive,
    countOvksNegative,
    countOvks,
    actOvks,
    countPositive,
    realEstateName,
  } = realEstateRating;

  const {
    fetchRealEstateRatingByPartner,
    data: realEstateRatingByPartner,
    ...realEstateRatingByPartnerState
  } = useGetRealEstateRatingByPartner();
  const { exportPartnerRatingByRealEstateExcelReport, ...partnerRatingByRealEstateExcelState } =
    useExportPartnerRatingByRealEstateExcelReport();

  const params = {
    partnerGuid: partnerRating.partnerGuid,
    realEstateGuid: realEstateRating.realEstateGuid,
    serviceTypeId: serviceType?.serviceTypeId,
    year,
  };
  const mapKey = Object.values(params).filter(Boolean).join('-');

  useEffect(() => {
    if (!open) return;
    fetchRealEstateRatingByPartner(partnerRating.partnerGuid, realEstateRating.realEstateGuid, {
      params: { serviceTypeId: serviceType?.serviceTypeId, year },
    });
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const realEstatesRating = realEstateRatingByPartner.get(mapKey) || [];

  return (
    <>
      <TableRow hover style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <b>{realEstateName}</b>

            <IconButton aria-label="Развернуть строку" size="small">
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </Box>
        </TableCell>

        <TableCell>{countPositive}</TableCell>
        <TableCell>{countOvksPositive}</TableCell>
        <TableCell>{countNegative}</TableCell>
        <TableCell>{countOvksNegative}</TableCell>
        <TableCell>{countOvks}</TableCell>
        <TableCell>{actOvks}</TableCell>

        {criteriaRatingsByServiceType.map((criteriaRating) => {
          const foundCriteriaRating = criteriaRatings.find(
            ({ criteriaRatingId }) => criteriaRatingId === criteriaRating.criteriaRatingId,
          );

          return <TableCell key={criteriaRating.criteriaRatingId}>{foundCriteriaRating?.value ?? '—'}</TableCell>;
        })}
      </TableRow>

      <PartnerRatingByMonthTableRow
        {...realEstateRatingByPartnerState}
        open={open}
        realEstatesRating={realEstatesRating}
        criteriaRatingsByServiceType={criteriaRatingsByServiceType}
        exportExcelLoading={partnerRatingByRealEstateExcelState.loading}
        onExportExcel={() =>
          exportPartnerRatingByRealEstateExcelReport(partnerRating.partnerGuid, realEstateRating.realEstateGuid, {
            params,
          })
        }
      />
    </>
  );
};

export default PartnerRatingTableRow;
